import {
  Button,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
  styled,
} from "@mui/material";
import React, { useState, useContext, useEffect } from "react";
import PayoutForm from "../payout-management/PayoutForm";
import PlanSetting from "../plan/PlanSetting";
import AdvanceSettings from "../admin/advanced-setting/AdvanceSettings";
import ClubProfile from "../admin/club/ClubProfile";
import { AuthContext } from "../auth/AuthContext";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { AccountSetupAPI } from "../../api/AccountSetupAPI";
import { stepperAction } from "../../redux/reducer/stepperReducer";
import { useNavigate } from "react-router-dom";
import Loader from "../../component/Loader";

const rootStyle = getComputedStyle(document.documentElement);
const color = rootStyle.getPropertyValue("--hoverColorBold").trim();

const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
  "& .MuiStepConnector-line": {
    borderColor: color, // Change connector line color
  },
}));

const AccountSetup = () => {
  const { getCurrentUser } = useContext(AuthContext);
  const userInfo = useSelector((store) => store.user.userInfo);
  const selectedClub = useSelector((store) => store.user.selectedClub);
  const [isLoading, setIsLoading] = useState(false);
  const { activeTab, configId, stepperDetails, isPayoutCompleted } = useSelector((store) => store.stepper);
  const [isUpdated, setIsUpdated] = useState(false);
  const [subscriptionStatus, setSubscriptionStatus] = useState("");

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const fetchStepsDetails = async () => {
    try {
      setIsLoading(true);
      const response = await AccountSetupAPI.getAllSteps(
        selectedClub.clubId,
        userInfo.userId
      );

      dispatch(stepperAction.setStepperDetails(response.Data));
      dispatch(stepperAction.setConfigId(response.Data.accountSetupConfigId))
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (userInfo.userId) {
      fetchStepsDetails();
    }
    setIsUpdated(false);
  }, [isUpdated, userInfo.userId]);

 

  const handleAfterCompleteAllSteps = async () => {
    const stepper = {
      clubId: selectedClub.clubId,
      accountSetupIsCompleted: true,
    }
    try {
      const response = await AccountSetupAPI.postStepper(stepper);
      getCurrentUser();
      navigate('/', { state: { message: 'Welcome to Sport Mingle' } });
    } catch (error) {

    }
  }

  return (
    <div className="account_setup_container">
      {isLoading && <Loader />}
      <div className="account_setup_stepper">
        <Stepper
          activeStep={activeTab}
          connector={<CustomStepConnector />}
          alternativeLabel
        >
          {stepperDetails?.steps?.map((data, index) => (
            <Step key={data.step}>
              <StepLabel
                StepIconProps={{
                  sx: {
                    color: (theme) =>
                      activeTab === index
                        ? 'var(--hoverColorBold)'
                        : theme.palette.text.disabled,
                    '&.Mui-active': {
                      color: 'var(--hoverColorBold)',
                    },
                    '&.Mui-completed': {
                      color: 'var(--hoverColorBold)',
                    },
                  },
                }}
              >{data.stepName}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </div>
      {stepperDetails.steps?.map((step) => (
        <>
          {step.step == 0 && activeTab == 0 && (
            <div className="account_setup_btns">
              <Button
                disabled={activeTab <= 0}
                onClick={() =>
                  dispatch(stepperAction.setActiveTab(activeTab - 1))
                }
                variant="contained"
              >
                Back
              </Button>
              <Button
                disabled={!step.isStepCompleted || (!subscriptionStatus === "active" || !subscriptionStatus === "trialing")}
                onClick={() =>
                  dispatch(stepperAction.setActiveTab(activeTab + 1))
                }
                variant="contained"
              >
                Save & Next
              </Button>
            </div>
          )}

          {step.step == 1 && activeTab == 1 && (
            <div className="account_setup_btns">
              <Button
                disabled={activeTab <= 0}
                onClick={() =>
                  dispatch(stepperAction.setActiveTab(activeTab - 1))
                }
                variant="contained"
              >
                Back
              </Button>
              <Button
                disabled={!step.isStepCompleted || !isPayoutCompleted}
                onClick={() =>
                  dispatch(stepperAction.setActiveTab(activeTab + 1))
                }
                variant="contained"
              >
                Save & Next
              </Button>
            </div>
          )}
          

          {step.step == 2 && activeTab == 2 && (
            <div className="account_setup_btns">
              <Button
                disabled={activeTab <= 0}
                onClick={() =>
                  dispatch(stepperAction.setActiveTab(activeTab - 1))
                }
                variant="contained"
              >
                Back
              </Button>
              <Button
                disabled={!step.isStepCompleted}
                onClick={() =>
                  dispatch(stepperAction.setActiveTab(activeTab + 1))
                }
                variant="contained"
              >
                Save & Next
              </Button>
            </div>
          )}
          {step.step == 3 && activeTab == 3 && (
            <div className="account_setup_btns">
              <Button
                disabled={activeTab <= 0}
                onClick={() =>
                  dispatch(stepperAction.setActiveTab(activeTab - 1))
                }
                variant="contained"
              >
                Back
              </Button>
              <div className="account_setup_completed">
                <Button disabled={!step.isStepCompleted} variant="text" onClick={handleAfterCompleteAllSteps}>
                  done
                </Button>
              </div>

            </div>
          )}
        </>
      ))}
      <div className="account_setup_body">
        {activeTab == 0 && (
          <PlanSetting
            setIsUpdated={setIsUpdated}
            setSubscriptionStatus={setSubscriptionStatus}
            subscriptionStatus={subscriptionStatus}
          />
        )}
        {activeTab == 1 && <PayoutForm setIsUpdated={setIsUpdated} />}

        {activeTab == 2 && <AdvanceSettings />}
        {activeTab == 3 && <ClubProfile />}
      </div>
    </div>
  );
};

export default AccountSetup;
